import { isEmpty } from 'lodash';
import React, { useCallback, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { routes, searchSettings } from '../../../config';
import { SvgClose } from '../../../icons/';
import './style.scss';

const MAX_CHAR_LENGTH = searchSettings.maxInputCharLength;

export function SearchBar() {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const [query, setQuery] = useState(() => {
    return new URLSearchParams(history.location.search).get('q') || '';
  });

  const input = {
    attributes: {
      autoCapitalize: 'none',
      autoComplete: 'off',
    },
    values: {
      placeholder: t('placeholder.vod'),
      value: query,
      debounceTimeout: searchSettings.debounceTimeout,
      maxLength: MAX_CHAR_LENGTH,
    },
    events: {
      onChange: useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
      }, []),
    },
  } as const;

  return (
    <div className={'searchbar-container'}>
      <form
        onSubmit={(event) => {
          event.preventDefault();

          if (isEmpty(query)) {
            return;
          }

          if (location.pathname.includes(routes.search.base)) {
            history.replace(`?q=${query}`);
            return;
          }

          history.push(`${routes.search.base}?q=${query}`);
        }}
      >
        <div className="searchField">
          <label htmlFor="search" className="visually-hidden">
            Search
          </label>
          {query.length > 0 && (
            <button
              type="button"
              onClick={() => setQuery('')}
              className="search-close-button"
              aria-label="clear search"
            >
              <SvgClose />
            </button>
          )}
          <DebounceInput
            id="search"
            type="search"
            className="searchInput"
            {...input.attributes}
            {...input.values}
            {...input.events}
          />
          <button className="searchSubmit">
            <span className="searchIcon">E</span>
          </button>
        </div>
      </form>
    </div>
  );
}
